/**
 * 引导程序
 */
import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';
// import { getState } from './redux/store';

if (!__PRIVATE__) {
  if (__HOST_STAGING__ || __HOST_PRODUCTION__) {
    const environment = __HOST_STAGING__ ? 'staging' : 'production';

    Sentry.init({
      dsn: __BUILD_IN__
        ? 'https://4047a0274da24e839a08d370000be713@sentry.buildin.ai/2'
        : 'https://5a8c3a04542b43ea966b1cb9a747322c@sentry.allflow.cn/2',
      autoSessionTracking: true,
      tracesSampleRate: 1.0,
      ignoreErrors: [
        // https://stackoverflow.com/a/50387233/3382144
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
        //
        "Unexpected token '<'",
      ],
      // integrations: [new Integrations.BrowserTracing()],
      // tracesSampleRate: 0.1,
      environment,
      release: import.meta.env.VITE_GIT_COMMIT,
      // beforeSend(event) {
      //   const { user } = getState();
      //   event.user = { id: user.uuid, username: user.nickname };
      //   return event;
      // },
    });
  }
}
